import EnumHelpers from './Enums';
import ObjectHelper from './Object';
export { EnumHelpers };

export default class {
    constructor() {
        // tslint:disable-next-line:no-unused-expression
        new ObjectHelper();
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/index.ts